module.exports = __webpack_public_path__ + "static/media/truck.834fbe20.jpg";